import { SelectProps } from 'app/components/Modules/Form/typing'
import Select from 'app/components/UI-Elements/DataEntry/Select'
import { InvoiceDamagesOptions } from 'app/constants/Enums'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'
import { useIntl } from 'react-intl'

type Option = { value: string; label: React.ReactNode }

interface Props extends SelectProps<Option> {
  onFilter: (value: unknown, option: unknown) => void
  value?: string
}

const DamageToggle: React.FC<Props> = ({ onFilter, value, ...others }) => {
  const { formatMessage } = useIntl()
  const { tRoute } = useTranslation({ scope: 'invoice.index.damages.options' })

  const placeholder = formatMessage({
    id: `component.data_entry.select.placeholder.invoice.damages`
  })

  return (
    <Select<Option>
      filterOption={false}
      entries={InvoiceDamagesOptions.map((damage) => ({
        value: damage,
        label: tRoute({ id: damage })
      }))}
      style={{ minWidth: 120 }}
      placeholder={placeholder}
      selectValueBy={'value'}
      selectLabelBy={'label'}
      onChange={onFilter}
      allowClear={true}
      value={value}
      {...others}
    />
  )
}

export default DamageToggle
